import {defineAsyncComponent} from 'vue'
const KeywordsRouter = [
  {
    path: 'manage',
    name: 'KeywordManage',
    component: () => import('@/views/Keywords/KeywordManage/Index.vue'),
    meta: {
      key: 'keywords'
    }
  },
  {
    path: 'apply',
    name: 'KeywordApply',
    component: () => import('@/views/Keywords/KeywordManage/Index.vue'),
    meta: {
      key: 'keywords'
    }
  },
  {
    path: 'stores',
    name: 'KeywordStores',
    component: () => import('@/views/Keywords/Stores/Index.vue'),
    meta: {
      key: 'keywords'
    }
  },
]
export {KeywordsRouter}
